import { styled } from '../styled';

export const DetailsArrow = styled('div', {
  display: 'flex',
  // alignItems: "center",
  padding: '0 $8',
});
